import styled from 'styled-components';
import { FontSize } from '../../../common/styles/constants';

export const AdsContainer = styled.div`
  margin-bottom: 32px;
`;

export const AdvertisementText = styled.text`
  display: inline-block;
  font-size: ${FontSize.EXTRA_SMALL};
  text-align: center;
  text-transform: uppercase;
  width: 100%;
  &::after {
    content: 'Advertisement';
  }
`;
